import { render, staticRenderFns } from "./newContract.vue?vue&type=template&id=bf51ef60&scoped=true&"
import script from "./newContract.vue?vue&type=script&lang=js&"
export * from "./newContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf51ef60",
  null
  
)

export default component.exports